export enum PlayerNotificationType {
  WITHDRAW_APPROVED = 1,
  DEPOSIT_SETTLED = 2,
  ACCOUNT_VERIFIED = 3,
  AVAILABLE_BONUS = 4,
  GAME_LIMIT_EXCEEDED = 5,
  CUSTOM_NOTIFICATION = 6,
  AVAILABLE_BONUS_EXPIRED = 7,
  WITHDRAW_REJECTED = 8,
}

export interface IPlayerNotificationTemplateTranslation {
  id: number;
  title: string;
  languageId: number;
  description: string;
}

interface IPlayerNotificationTemplate {
  id: number;
  name: string;
  iconUrl: string | null;
  websiteId: number;
  type: number;
  translations: IPlayerNotificationTemplateTranslation[];
}

export interface IPlayerNotification {
  id: number;
  playerId: number;
  createdAt: number;
  seenAt: number | null;
  meta: Record<string, unknown>;
  template: IPlayerNotificationTemplate;
}
